import { useSelector } from "react-redux";
import NoRecords from "../../../Components/Atoms/NoRecord";
import { Delete, Edit } from "@mui/icons-material";
import { useState } from "react";
import CustomButton from "../../../Components/Atoms/CustomButton";
import AvailableStatus from "../../../Components/Atoms/AvailableStatus";
import { NOTIFY_TYPE } from "../../../Constant";
import CustomDialog from "../../../Components/Molecules/CustomDialog";
import CreateReminder from "./CreateReminder";
import { useFormik } from "formik";
import * as Yup from "yup";
import ConfirmModal from "../../../Components/Molecules/ConfirmModal/Index";

const VisitorReminderIntervals = ({ formik, type }) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [editIndex, setEditIndex] = useState(null);

  const handleOpen = (type, data = null, index = null) => {
    setOpen(true);
    setData(data);
    setEditIndex(index);
  };

  const handleClose = () => {
    setOpen(false);
    setEditIndex(null);
  };

  const action = data ? "edit" : "new";

  const visitor_formik = useFormik({
    initialValues: {
      mode: "TIME",
      hours: 1,
      minutes: 0,
      days: 1,
      emails: [],
      to_number: "",
      notify_type: "EMAIL",
    },
    onSubmit: (values) => {
      const { emails = [] } = values;
      const mod_emails = emails.map((e) => e.email);
      if (action === "new") {
        const res = [
          ...formik.values.reminder_interval,
          { ...values, emails: mod_emails },
        ];
        formik.setFieldValue("reminder_interval", res);
      } else {
        const res = [...formik.values.reminder_interval];
        res[editIndex] = { ...values, emails: mod_emails };
        formik.setFieldValue("reminder_interval", res);
      }
      handleClose();
    },
    validationSchema: Yup.object().shape({
      mode: Yup.string().required("Required"),
      emails: Yup.array().when(["$notify_type"], ([notify_type], schema) => {
        if (["EMAIL", "ALL"].includes(notify_type)) {
          return Yup.array().min(1, "Minimum 1 Email is required");
        } else {
          return schema;
        }
      }),
      to_number: Yup.number().when(
        ["$notify_type"],
        ([notify_type], schema) => {
          if (["SMS", "ALL"].includes(notify_type)) {
            return Yup.number().required("Required");
          } else {
            return schema;
          }
        }
      ),
      hours: Yup.number().when(
        ["$mode", "$minutes"],
        ([mode, minutes], schema) => {
          if (mode === "TIME") {
            return Yup.number()
              .required("Required")
              .min(
                Number(minutes) === 0 ? 1 : 0,
                `Minimum ${Number(minutes) === 0 ? 1 : 0}`
              )
              .max(23, "Maximum 23");
          } else {
            return schema;
          }
        }
      ),
      minutes: Yup.number().when(["$mode"], ([mode], schema) => {
        if (mode === "TIME") {
          return Yup.number()
            .required("Required")
            .min(0, "Minimum 0")
            .max(59, "Maximum 59");
        } else {
          return schema;
        }
      }),
      days: Yup.number().when(["$mode"], ([mode], schema) => {
        if (mode === "DATE") {
          return Yup.number()
            .required("Required")
            .min(1, "Minimum 1")
            .max(45, "Maximum 45");
        } else {
          return schema;
        }
      }),
    }),
  });

  const handleDelete = (indexToRemove) => {
    const updatedList = formik.values.reminder_interval.filter(
      (_item, index) => index !== indexToRemove
    );
    formik.setFieldValue("reminder_interval", updatedList);
  };

  //

  const [deleteConfig, setDeleteConfig] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const handleDeleteOpen = () => setDeleteOpen(true);
  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };
  return (
    <>
      <CustomDialog
        maxWidth="md"
        title={data ? "UPDATE REMINDER" : "CREATE REMINDER"}
        handleClose={() => {
          handleClose();
        }}
        open={open}
      >
        <div>
          <CreateReminder
            handleClose={handleClose}
            data={data}
            formik={visitor_formik}
          />
        </div>
      </CustomDialog>

      <CustomDialog
        maxWidth="sm"
        title={`S.NO - ${deleteConfig?.s_no}`}
        handleClose={handleDeleteClose}
        open={deleteOpen}
      >
        <ConfirmModal
          message={"Are you sure you want to delete this record ?"}
          subMessage={
            "This will delete this recird permanently, You cannot undo This Action."
          }
          handleSubmit={() => {
            handleDelete(deleteConfig?.delete_index);
            handleDeleteClose();
          }}
          handleClose={handleDeleteClose}
        />
      </CustomDialog>

      <div className="d-flex-juscon-flex-end-align-center mb-10">
        <CustomButton
          label={"New Reminder"}
          size="small"
          action={"NEW"}
          onClick={() => handleOpen("new")}
        />
      </div>
      <div className="tblWrpr mb-15">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>S.NO</th>
                <th>NOTIFY TYPE</th>
                <th>MODE</th>
                <th>INTERVAL</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {formik.values.reminder_interval?.length > 0 ? (
                formik.values.reminder_interval?.map((data, index) => (
                  <tr key={index}>
                    <td> {index + 1}</td>
                    <td> {NOTIFY_TYPE[data?.notify_type]}</td>
                    <td>
                      <AvailableStatus
                        customCls={
                          data?.mode === "TIME"
                            ? "index-green"
                            : "index-orange-mild"
                        }
                        status={data?.mode}
                      />
                    </td>

                    <td>
                      {data?.mode === "TIME"
                        ? `${data?.hours} Hr - ${data?.minutes} Min`
                        : `${data?.days} Day (s)`}
                    </td>
                    <td>
                      <div className="view">
                        <button
                          type="button"
                          onClick={() => {
                            handleOpen("edit", data, index);
                          }}
                        >
                          <Edit />
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setDeleteConfig({
                              ...data,
                              delete_index: index,
                              s_no: index + 1,
                            });
                            handleDeleteOpen();
                          }}
                        >
                          <Delete />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <NoRecords />
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default VisitorReminderIntervals;
